import {ROLE_GUEST} from "../utils/roles";

import {AUTH_USER, UNAUTH_USER} from "../actions/types";

export default function (state = {}, action) {
    switch (action.type) {
        case AUTH_USER:
            return {...state, authenticated: true, role: action.payload};
        case UNAUTH_USER:
            return {...state, authenticated: false, role: ROLE_GUEST};
    }

    return state;
}